import { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import WeightInput from '../../../../components/form/WeightInput'
import { setWeight } from '../adGroupSlice'
import { integerValue } from '../../../../utils'

const Weights = ({ errors }) => {
  const dispatch = useDispatch()
  const { mobileWeight, pcWeight, keywordExtensionWeight } = useSelector(
    state => state.ad.adGroup.form
  )
  const handleChange = useCallback(
    ({ target: { name, value } }) =>
      dispatch(
        setWeight({
          type: name,
          value: integerValue(value),
        })
      ),
    [dispatch]
  )
  return (
    <div
      className={classNames('area_item', {
        error: errors.deviceWeight || errors.keywordExtensionWeight,
      })}>
      <strong className="subtit_box">입찰가중치</strong>
      <div className="cont_card">
        <div className="tit_card">
          <strong className="tit_detail">
            디바이스
            <HelpTooltip>
              기본입찰가에 대한 가중치를 노출 디바이스별로 설정할 수 있습니다.
            </HelpTooltip>
          </strong>
        </div>
        <div className="item_card">
          <div className="group_weight">
            <ul className="list_weight">
              <li>
                <div className="tit_card">
                  <strong className="tit_detail">모바일</strong>
                </div>
                <WeightInput
                  name="mobileWeight"
                  value={mobileWeight}
                  onChange={handleChange}
                  error={errors.mobileWeight}
                  min={10}
                  max={500}
                  step={1}
                  maxLength={3}
                />
              </li>
              <li>
                <div className="tit_card">
                  <strong className="tit_detail">PC</strong>
                </div>
                <WeightInput
                  name="pcWeight"
                  value={pcWeight}
                  onChange={handleChange}
                  error={errors.pcWeight}
                  min={10}
                  max={500}
                  step={1}
                  maxLength={3}
                />
              </li>
            </ul>
            {errors.deviceWeight ? (
              <p className="txt_error">{errors.deviceWeight}</p>
            ) : (
              <p className="desc_item">
                모바일/PC 입찰 가중치는 최소 10%부터 최대 500% 까지 1% 단위로
                설정 가능합니다.
                <br />
                가중치 설정으로 입찰가 70원 이하 값 발생 시 최소 금액 70원으로
                입찰됩니다.
              </p>
            )}
          </div>
        </div>
        <div className="item_card">
          <div className="group_weight">
            <div className="tit_card">
              <strong className="tit_detail">
                키워드확장
                <HelpTooltip>
                  기본입찰가에 대한 가중치를 키워드확장인 경우에 대해 설정할 수
                  있습니다.
                </HelpTooltip>
              </strong>
            </div>
            <ul className="list_weight">
              <li>
                <WeightInput
                  name="keywordExtensionWeight"
                  value={keywordExtensionWeight}
                  onChange={handleChange}
                  error={errors.keywordExtensionWeight}
                  min={10}
                  max={500}
                  step={1}
                  maxLength={3}
                />
              </li>
            </ul>
            {errors.keywordExtensionWeight ? (
              <p className="txt_error">{errors.keywordExtensionWeight}</p>
            ) : (
              <p className="desc_item">
                키워드 확장 입찰 가중치는 최소 10%부터 최대 500% 까지 1% 단위로
                설정 가능합니다.
                <br />
                가중치 설정으로 입찰가 70원 이하 값 발생 시 최소 금액 70원으로
                입찰됩니다.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
Weights.propTypes = {
  errors: PropTypes.shape({
    mobileWeight: PropTypes.string,
    pcWeight: PropTypes.string,
    deviceWeight: PropTypes.string,
    keywordExtensionWeight: PropTypes.string,
  }),
}
export default Weights
